// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"page-title_pageTitle__31hYh","titleText":"page-title_titleText__1rqYI"};